import styled from 'styled-components';

export type UIButtonColor = 'green' | 'brightgreen' | 'red' | 'brightred' | 'transparentoutlined';

const COLORS: Record<UIButtonColor, {
  bg: string;
  fg: string;
  fgHover?: string,
  hover: string,
  border?: string,
  borderHover?: string,
}> = {
  green: {
    bg: '#d1f2dc',
    fg: '#1e705a',
    hover: '#c0ebcf',
  },
  brightgreen: {
    bg: '#19be51',
    fg: '#fff',
    hover: '#15a847',
  },
  red: {
    bg: 'rgba(210, 38, 0, 0.15)',
    fg: '#d22600',
    hover: 'rgba(210, 38, 0, 0.22)',
  },
  brightred: {
    bg: '#d22600',
    fg: '#fff',
    hover: '#b92100',
  },
  transparentoutlined: {
    bg: 'transparent',
    fg: '#505050',
    fgHover: '#202020',
    hover: 'transparent',
    border: '#505050',
    borderHover: '#202020',
  },
};

// Shared pill button used across settings screens. `color` picks the green
// (primary/positive) or red (destructive) palette; everything else (radius,
// font, disabled treatment) is shared so the buttons stay visually consistent.
// Per styled-components v6, the prop is declared without the `$` prefix here
// but passed/read with it (MakeTransient adds the `$` at the type level).
export const UIButton = styled.button<{ color?: UIButtonColor }>`
  background: ${({ $color }) => COLORS[$color ?? 'green'].bg};
  color: ${({ $color }) => COLORS[$color ?? 'green'].fg};
  border: ${({ $color }) => {
    const border = COLORS[$color ?? 'green'].border;
    return border ? `1px solid ${border}` : 'none';
  }};
  border-radius: 26px;
  padding: 8px 20px;
  font-family: Avenir, Montserrat, sans-serif;
  font-size: 14px;
  font-weight: 800 !important;
  line-height: normal;
  cursor: pointer;
  box-shadow: none;
  white-space: nowrap;
  flex-shrink: 0;

  &:hover {
    background: ${({ $color }) => COLORS[$color ?? 'green'].hover};
    ${({ $color }) => {
      const borderHover = COLORS[$color ?? 'green'].borderHover;
      return borderHover ? `border-color: ${borderHover};` : '';
    }}
    ${({ $color }) => {
      const fgHover = COLORS[$color ?? 'green'].fgHover;
      return fgHover ? `color: ${fgHover};` : '';
    }}

  }
  &:disabled {
    background: #e9e9e9;
    color: #929292;
    border-color: transparent;
    cursor: default;
    opacity: 1;
  }
  &:disabled:hover {
    background: #e9e9e9;
    color: #929292;
    border-color: transparent;
    opacity: 1;
  }
`;
